import Vue from "vue";
import Donut from "vue-css-donut-chart";
import "vue-css-donut-chart/dist/vcdonut.css";
import { createNamespacedHelpers } from "vuex";
import { createTooltipContent } from "@/utils";
import SvgRenderer from "@/components/svgRenderer/svgRenderer.vue";

Vue.use(Donut);
const { mapGetters: brandingGetters } = createNamespacedHelpers("branding"),
	{ mapGetters: userGetters } = createNamespacedHelpers("user");

import { REQUEST_STATE, STATUS_CODE } from "@/enums";

export default {
	components: { SvgRenderer },

	data() {
		return {
			state: REQUEST_STATE.LOADING,
			REQUEST_STATE,
			data: null,
			itemsLoading: true,
			monthlyGoalModalData: null,
			reduction_wpg: 0,
			sections_wpg: [{ value: 0 }], // eslint-disable-line object-curly-newline
			reduction_cpg: 0,
			sections_cpg: [{ value: 0 }], // eslint-disable-line object-curly-newline
		};
	},

	methods: {
		load,
		createTooltipContent,
	},

	computed: {
		...userGetters(["activeOutlet"]),
		...brandingGetters(["colors"]),
	},

	mounted() {
		this.load();
		// this.$eventBus.$on("reloadSingleTrackedItemsData", this.load);
	},

	beforeDestroy() {
		// this.$eventBus.$off("reloadSingleTrackedItemsData", this.load);
	},
};

async function load() {
	try {
		this.state = REQUEST_STATE.LOADING;

		const { data } = await this.$api.getTrackedItemsPerformance(),
			PCT = 100;
		this.data = data;
		this.reduction_wpg = Math.round(Math.min(PCT, Math.max(0, data.avg_wpg_reduction * PCT)));
		this.reduction_cpg = Math.round(Math.min(PCT, Math.max(0, data.avg_cpg_reduction * PCT)));
		this.sections_wpg = [
			{
				value: this.reduction_wpg,
				color: this.colors[1],
			},
		];
		this.sections_cpg = [
			{
				value: this.reduction_cpg,
				color: this.colors[1],
			},
		];
	} catch (error) {
		if (error.response && error.response.status === STATUS_CODE.MISSING_DATA) this.state = REQUEST_STATE.MISSING_DATA;
	} finally {
		this.$emit("notifyLoaded");
	}
}
